import Icon from "@mui/icons-material/Group";
import StaffCreate from "./StaffCreate";
import StaffEdit from "./StaffEdit";
import StaffList from "./StaffList";
import StaffMemberDashboard from "./StaffMemberDashboard";

export default {
  list: StaffList,
  edit: StaffEdit,
  create: StaffCreate,
  show: StaffMemberDashboard,
  icon: Icon,
  label: "Staff",
  options: { label: "Staff" },
  name: "employees",
};
